import React, { useEffect, useMemo, useRef, useState } from "react";
import KuyumcuLeftSideNavbar from "./components/KuyumcuLeftSideNavbar";
// import PremiumBackground from "./components/PremiumBackground";

import {
  Box,
  Button,
  Dialog,
  DialogContent,
  DialogTitle,
  DialogActions,
  MenuItem,
  TextField,
} from "@mui/material";
import { useParams, useNavigate } from "react-router-dom";
import axiosInstance from "../../api/axiosInstance";
import TableViewIcon from "@mui/icons-material/TableView";
import DescriptionIcon from "@mui/icons-material/Description";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import PaymentsIcon from "@mui/icons-material/Payments";
import PrintIcon from "@mui/icons-material/Print";
import AddIcon from "@mui/icons-material/Add";
import SaveIcon from "@mui/icons-material/Save";
import CloseIcon from "@mui/icons-material/Close";
import SwapHorizIcon from "@mui/icons-material/SwapHoriz";

import { toStartOfDay, toEndOfDay } from "./utils/DateUtils";
import * as XLSX from "xlsx-js-style";
import "./css/KuyumcuMainPage.css";
import "./css/KuyumcuHesapIslemlerPage.css";
import ProsetDataGrid from "./components/KuyumcuDataGrid";
import ProsetBackButton from "./components/ProsetBackButton";
import ProsetPopup from "./components/ProsetPopup";
import SilmeUyariPopup from "./components/SilmeUyariPopup";
import KuyumcuDropBox from "./components/KuyumcuDropBox";

import { getUserId } from "../../utils/getUserId";
import { usePermission } from "../../context/PermissionContext";
import YetkisizErisim from "./components/YetkisizErisim";

import { formatNumberTR } from "./utils/numberFormat";
import { formatEnum } from "./utils/enumIslemTurFormat";

import { downloadHesapExcel } from "./reports/HesapIslemExcelReport";
import { downloadHesapWord } from "./reports/HesapIslemWordReport";
import { printSelectedFis } from "./fis/HesapIslemFisPrintService";


/* ENUM SABİTLER */
const islemTurleri = {
  NAKIT: [
    "NAKIT_ALINDI",
    "NAKIT_VERILDI",
  ],
  ALTIN: ["ALTIN_ALINDI", "ALTIN_VERILDI"],
  ZIYNET: ["ZIYNET_ALINDI", "ZIYNET_VERILDI"],
};

const BAGLANTILI_ISLEM_TURLERI = [
  "NAKIT_BAKIYE_GRAMA_CEVRILDI",
  "GRAM_BAKIYE_NAKITE_CEVRILDI",
];

const isBaglantiliIslem = (tur) =>
  BAGLANTILI_ISLEM_TURLERI.includes(tur);

const baglantiliIslemLabel = (tur) => {
  if (isBaglantiliIslem(tur)) {
    return "Bağlantılı İşlem";
  }

  return tur || "";
};

const parseDecimalTR = (value) => {
  if (value === null || value === undefined || value === "") return 0;

  const raw = String(value).trim().replace(/\s/g, "");
  if (!raw) return 0;

  // 1.000,50 -> 1000.50; 1000.50 -> 1000.50
  const normalized = raw.includes(",")
    ? raw.replace(/\./g, "").replace(",", ".")
    : raw;

  const parsed = Number(normalized);
  return Number.isFinite(parsed) ? parsed : 0;
};

const ziynetShortMap = {
  "Yeni ATA": "YA",
  "Yeni YARIM": "YY",
  "Yeni ÇEYREK": "YÇ",
  "Eski ATA": "EA",
  "Eski YARIM": "EY",
  "Eski ÇEYREK": "EÇ",
};

const formatIslemTurWithZiynet = (row, mobilMi = false) => {
  if (!row?.islemTur) return "";

  if (isBaglantiliIslem(row.islemTur)) {
    return baglantiliIslemLabel(row.islemTur);
  }

  // Normal enum text
  const baseText = formatEnum(row.islemTur);

  // Ziynet değilse direkt dön
  if (!row.islemTur.startsWith("ZIYNET")) {
    return baseText;
  }

  // Ziynet ise stok kısaltması ekle
  const short = ziynetShortMap[row.stokAdi];

  return short ? `${baseText} (${short})` : baseText;
};

let altinSatirSequence = 0;

const createAltinSatir = () => ({
  _rowKey: `altin-satir-${Date.now()}-${++altinSatirSequence}`,
  _iscilikTouched: false,
  stokId: "",
  miktar: "",
  milyem: "",
  hasGram: "",
  adet: "",
  iscilik: "",
  iscilikGram: "",
  alinanIscilik: "",
  verilenIscilik: "",
});

/* ===========================================================
   ANA SAYFA
=========================================================== */
const KuyumcuHesapIslemlerPage = () => {
  const navigate = useNavigate();
  const { hesapId } = useParams();

  const { can, isLoading } = usePermission();

  // ====== YETKİ KODLARI (DB'DEKİ KODLARLA EŞLEŞTİR) ======
  const PERM_VIEW = "HESAP_ISLEMLER_VIEW";
  const PERM_CREATE = "HESAP_ISLEMLER_CREATE";
  const PERM_UPDATE = "HESAP_ISLEMLER_UPDATE";
  const PERM_DELETE = "HESAP_ISLEMLER_DELETE";

  const canView = !isLoading && can(PERM_VIEW);
  const canCreate = !isLoading && can(PERM_CREATE);
  const canUpdate = !isLoading && can(PERM_UPDATE);
  const canDelete = !isLoading && can(PERM_DELETE);

  const [hesapAdi, setHesapAdi] = useState("");

  const [rows, setRows] = useState([]);
  // ===============================
  //   TARİH FİLTRE (BAŞLANGIÇ / BİTİŞ)
  // ===============================
  const [filterStart, setFilterStart] = useState(""); // yyyy-mm-dd
  const [filterEnd, setFilterEnd] = useState("");     // yyyy-mm-dd
  const [preset, setPreset] = useState("ALL");        // TODAY, LAST7, LAST30, PREV_MONTH, ALL
  const [filteredRows, setFilteredRows] = useState([]);

  const [loadingIds, setLoadingIds] = useState([]);

  const [stoklar, setStoklar] = useState([]);

  const [open, setOpen] = useState(false);
  const [editMode, setEditMode] = useState(false);

  const [silmePopupOpen, setSilmePopupOpen] = useState(false);
  const [silinecekId, setSilinecekId] = useState(null);

  const [altinKarsiligiMi, setAltinKarsiligiMi] = useState(false);
  const [paraBirimiKur, setParaBirimiKur] = useState("");
  const [guncelKur, setGuncelKur] = useState("");

  // ================= USER PROFIL KURLARI =================
  const [userKurCache, setUserKurCache] = useState({
    altinKur: null,
    dolarKur: null,
    euroKur: null,
  });
  const [userKurLoaded, setUserKurLoaded] = useState(false);

  // Kullanıcı elle değiştirirse override etmemek için
  const [guncelKurTouched, setGuncelKurTouched] = useState(false);
  const [paraKurTouched, setParaKurTouched] = useState(false);

  const [isNakitPopup, setIsNakitPopup] = useState(false);

  // ================= BAĞLANTILI İŞLEM POPUP =================
  const [baglantiliOpen, setBaglantiliOpen] = useState(false);
  const [baglantiliEditMode, setBaglantiliEditMode] = useState(false);
  const [baglantiliSaving, setBaglantiliSaving] = useState(false);
  const [baglantiliErrors, setBaglantiliErrors] = useState({});
  const [baglantiliForm, setBaglantiliForm] = useState({
    id: null,
    tarih: "",
    islemTur: "NAKIT_BAKIYE_GRAMA_CEVRILDI",
    miktar: "",
    nakitBirim: "TL",
    gramKur: "",
    nakitKur: "",
  });

  const [formErrors, setFormErrors] = useState({});

  const applyPreset = (key) => {
    const now = new Date();

    const todayStart = new Date(now);
    todayStart.setHours(0, 0, 0, 0);

    const fmt = (dt) => {
      const y = dt.getFullYear();
      const m = String(dt.getMonth() + 1).padStart(2, "0");
      const d = String(dt.getDate()).padStart(2, "0");
      return `${y}-${m}-${d}`;
    };

    if (key === "TODAY") {
      // Sadece bugün (Başlangıç=Bugün, Bitiş=Bugün)
      setFilterStart(fmt(todayStart));
      setFilterEnd(fmt(todayStart));
      return;
    }

    if (key === "LAST7") {
      const s = new Date(todayStart);
      s.setDate(s.getDate() - 6);
      setFilterStart(fmt(s));
      setFilterEnd(fmt(todayStart)); // bugün dahil
      return;
    }

    if (key === "LAST30") {
      const s = new Date(todayStart);
      s.setDate(s.getDate() - 29);
      setFilterStart(fmt(s));
      setFilterEnd(fmt(todayStart)); // bugün dahil
      return;
    }

    if (key === "PREV_MONTH") {
      const firstThisMonth = new Date(todayStart.getFullYear(), todayStart.getMonth(), 1);
      const lastPrevMonth = new Date(firstThisMonth);
      lastPrevMonth.setDate(0);
      const firstPrevMonth = new Date(lastPrevMonth.getFullYear(), lastPrevMonth.getMonth(), 1);

      setFilterStart(fmt(firstPrevMonth));
      setFilterEnd(fmt(lastPrevMonth));
      return;
    }

    if (key === "ALL") {
      setFilterStart("");
      setFilterEnd("");
    }
  };



  const getLocalDateTime = () => {
    const now = new Date();
    now.setMinutes(now.getMinutes() - now.getTimezoneOffset());
    return now.toISOString().slice(0, 16);
  };

  // ================= ALTIN POPUP STATE =================
  // ÜST (MASTER) ALANLAR: tek tarih, tek işlem türü, tek açıklama
  const [altinMaster, setAltinMaster] = useState({
    tarih: new Date().toISOString().slice(0, 16),
    islemTur: "",
    aciklama: "",
  });

  // ALT SATIRLAR: stok, miktar, milyem, hasGram, adet, işçilik, işçilikGram
  const [openAltinPopup, setOpenAltinPopup] = useState(false);
  const [altinSatirlari, setAltinSatirlari] = useState(() => [
    createAltinSatir(),
  ]);

  // Her satır için son işçilik isteğini takip eder.
  // Stok hızlı değiştirilirse eski API cevabı yeni satırı ezemez.
  const sonIscilikIstekRef = useRef({});

  const addRow = () => {
    setAltinSatirlari((prev) => [...prev, createAltinSatir()]);
  };

  const removeRow = (index) => {
    setAltinSatirlari((prev) => {
      const silinecek = prev[index];
      if (silinecek?._rowKey) {
        delete sonIscilikIstekRef.current[silinecek._rowKey];
      }
      return prev.filter((_, i) => i !== index);
    });
  };

  const hesaplaAltinSatir = (sourceRow) => {
    const row = { ...sourceRow };

    const miktarNum = parseFloat(row.miktar) || 0;
    const milyemNum = parseFloat(row.milyem) || 0;
    const iscilikNum = parseFloat(row.iscilik) || 0;
    const adetNum = parseInt(row.adet, 10) || 0;

    // Has Gram = miktar * (milyem / 1000)
    row.hasGram =
      miktarNum > 0 && milyemNum > 0
        ? (miktarNum * (milyemNum / 1000)).toFixed(2)
        : "";

    // İşçilik Gram:
    // Adet > 0 ise adet * (işçilik / 100)
    // Adet = 0 ise miktar * (işçilik / 1000)
    if (iscilikNum > 0) {
      const iscilikGram =
        adetNum > 0
          ? adetNum * (iscilikNum / 100)
          : miktarNum * (iscilikNum / 1000);

      row.iscilikGram = iscilikGram.toFixed(2);
    } else {
      row.iscilikGram = "";
    }

    return row;
  };

  // Miktar / milyem / adet / işçilik değişiklikleri
  const handleRowChange = (index, field, value, elleDegisti = false) => {
    setAltinSatirlari((prev) =>
      prev.map((currentRow, i) => {
        if (i !== index) return currentRow;

        return hesaplaAltinSatir({
          ...currentRow,
          [field]: value,
          ...(field === "iscilik" && elleDegisti
            ? { _iscilikTouched: true }
            : {}),
        });
      })
    );
  };

  // Stok seçildiğinde hesap + stok + işlem türü bazlı son geçerli
  // işçiliği getirir.
  //
  // ALTIN_ALINDI seçildiyse yalnızca son ALTIN_ALINDI işçiliği,
  // ALTIN_VERILDI seçildiyse yalnızca son ALTIN_VERILDI işçiliği gelir.
  const handleAltinStokChange = async (
    index,
    value,
    islemTurOverride = null
  ) => {
    const stokIdNum =
      value === "" || value === null || value === undefined
        ? ""
        : Number(value);

    const seciliIslemTur =
      islemTurOverride || altinMaster.islemTur;

    const rowKey = altinSatirlari[index]?._rowKey;

    if (!rowKey) {
      console.error("Altın satır anahtarı bulunamadı.", {
        index,
        satir: altinSatirlari[index],
      });
      return;
    }

    // Aynı satırda yapılan her sorguya artan bir istek numarası verilir.
    // Stok veya işlem türü hızlı değiştirilirse eski cevap yeni seçimi ezemez.
    const istekNo =
      (sonIscilikIstekRef.current[rowKey] || 0) + 1;

    sonIscilikIstekRef.current[rowKey] = istekNo;

    // Yeni stok veya işlem yönü seçildiğinde eski işçilik ekranda kalmasın.
    setAltinSatirlari((prev) =>
      prev.map((currentRow) =>
        currentRow._rowKey === rowKey
          ? hesaplaAltinSatir({
              ...currentRow,
              stokId: stokIdNum,
              iscilik: "",
              iscilikGram: "",
              _iscilikTouched: false,
            })
          : currentRow
      )
    );

    // İşlem türü seçilmeden yön bazlı sorgu yapılamaz.
    // Tür seçildiğinde handleAltinIslemTurChange seçili stokları tekrar sorgular.
    if (
      !stokIdNum ||
      !hesapId ||
      !seciliIslemTur
    ) {
      return;
    }

    if (
      seciliIslemTur !== "ALTIN_ALINDI" &&
      seciliIslemTur !== "ALTIN_VERILDI"
    ) {
      console.error(
        "Son işçilik sorgulanamadı: geçersiz işlem türü.",
        seciliIslemTur
      );
      return;
    }

    const userId = Number(getUserId());

    if (!userId) {
      console.error(
        "Son işçilik sorgulanamadı: geçerli kullanıcı ID bulunamadı."
      );
      return;
    }

    try {
      const response = await axiosInstance.get(
        "/islem-log-detay/son-iscilik",
        {
          params: {
            hesapId: Number(hesapId),
            stokId: stokIdNum,
            islemTur: seciliIslemTur,
          },
          headers: {
            "X-User-Id": String(userId),
          },
        }
      );

      const data = response?.data;

      setAltinSatirlari((prev) =>
        prev.map((currentRow) => {
          // Cevap yalnızca isteğin yapıldığı satıra uygulanır.
          if (currentRow._rowKey !== rowKey) {
            return currentRow;
          }

          // Satır için daha yeni bir sorgu yapıldıysa eski cevabı kullanma.
          if (sonIscilikIstekRef.current[rowKey] !== istekNo) {
            return currentRow;
          }

          // Kullanıcı stok seçimini değiştirdiyse eski stok cevabını uygulama.
          if (Number(currentRow.stokId) !== stokIdNum) {
            return currentRow;
          }

          // API cevabı gelmeden kullanıcı işçiliği elle değiştirdiyse ezme.
          if (currentRow._iscilikTouched) {
            return currentRow;
          }

          // Aynı hesap + stok + işlem türü için geçmiş işçilik yoksa boş bırak.
          if (data?.bulundu !== true || data?.iscilik == null) {
            return hesaplaAltinSatir({
              ...currentRow,
              iscilik: "",
              iscilikGram: "",
            });
          }

          return hesaplaAltinSatir({
            ...currentRow,
            iscilik: String(data.iscilik),
          });
        })
      );
    } catch (error) {
      console.error("Son işçilik isteği başarısız:", {
        status: error?.response?.status,
        data: error?.response?.data,
        message: error?.message,
        baseURL: error?.config?.baseURL,
        url: error?.config?.url,
        params: error?.config?.params,
      });
    }
  };

  // İşlem türü değiştiğinde seçili tüm stokların işçiliğini
  // yeni işlem yönüne göre tekrar getirir.
  const handleAltinIslemTurChange = (yeniIslemTur) => {
    setAltinMaster((prev) => ({
      ...prev,
      islemTur: yeniIslemTur,
    }));

    const mevcutSatirlar = altinSatirlari;

    // Önce önceki işlem yönünden kalan işçilikleri temizle.
    setAltinSatirlari((prev) =>
      prev.map((row) =>
        hesaplaAltinSatir({
          ...row,
          iscilik: "",
          iscilikGram: "",
          alinanIscilik:
            yeniIslemTur === "ALTIN_VERILDI"
              ? row.alinanIscilik
              : "",
          verilenIscilik:
                      yeniIslemTur === "ALTIN_ALINDI"
                        ? row.verilenIscilik
                        : "",
          _iscilikTouched: false,
        })
      )
    );

    // Stok seçilmiş satırlar için yeni işlem yönüne ait son işçiliği getir.
    mevcutSatirlar.forEach((row, index) => {
      if (row.stokId) {
        handleAltinStokChange(
          index,
          row.stokId,
          yeniIslemTur
        );
      }
    });
  };

  const handleAltinTopluKaydet = async () => {
    if (isLoading) return;
    if (!can(PERM_CREATE)) {
      alert("Altın işlemi ekleme yetkiniz yok.");
      return;
    }

    // Üst alan kontrolleri
    if (!altinMaster.tarih || !altinMaster.islemTur) {
      alert("Lütfen tarih ve işlem türünü seçin.");
      return;
    }

    // Satır kontrolleri
    for (const r of altinSatirlari) {
      if (!r.stokId) {
        alert("Her satır için stok seçimi zorunludur.");
        return;
      }
      if (!r.miktar) {
        alert("Her satır için miktar (gr) zorunludur.");
        return;
      }
      if (!r.milyem) {
        alert("Her satır için milyem/cm zorunludur.");
        return;
      }

      if (
        altinMaster.islemTur === "ALTIN_VERILDI" &&
        r.alinanIscilik !== "" &&
        r.alinanIscilik !== null &&
        r.alinanIscilik !== undefined
      ) {
        const alinanIscilikNum = Number(r.alinanIscilik);

        if (!Number.isFinite(alinanIscilikNum) || alinanIscilikNum < 0) {
          alert("İşçilik Maliyet 0 veya daha büyük bir sayı olmalıdır.");
          return;
        }
      }

      if (
        altinMaster.islemTur === "ALTIN_ALINDI" &&
        r.verilenIscilik !== "" &&
        r.verilenIscilik !== null &&
        r.verilenIscilik !== undefined
      ) {
        const verilenIscilikNum = Number(r.verilenIscilik);

        if (!Number.isFinite(verilenIscilikNum) || verilenIscilikNum < 0) {
          alert("İşçilik İade 0 veya daha büyük bir sayı olmalıdır.");
          return;
        }
      }
    }

    const userId = getUserId();

    const payload = {
      hesapId: Number(hesapId),
      kullaniciId: userId,
      tarih: altinMaster.tarih,
      islemTur: altinMaster.islemTur, // "ALTIN_ALINDI" / "ALTIN_VERILDI"
      aciklama: altinMaster.aciklama || "",
      satirlar: altinSatirlari.map((row) => ({
        stokId: row.stokId,
        miktar: Number(row.miktar || 0),
        milyem: Number(row.milyem || 0),
        hasGram: Number(row.hasGram || 0),
        adet: row.adet ? Number(row.adet) : 0,
        iscilik: Number(row.iscilik || 0),
        iscilikGram: Number(row.iscilikGram || 0),
        alinanIscilik:
            altinMaster.islemTur === "ALTIN_VERILDI" &&
            row.alinanIscilik !== ""
              ? Number(row.alinanIscilik)
              : null,
        verilenIscilik:
                    altinMaster.islemTur === "ALTIN_ALINDI" &&
                    row.verilenIscilik !== ""
                      ? Number(row.verilenIscilik)
                      : null,
      })),
    };

    try {
      // YENİ ENDPOINT: /islemler/altinTopluV2
      await axiosInstance.post("/islemler/altinTopluV2", payload);
      alert("Altın işlemi başarıyla kaydedildi.");
      setOpenAltinPopup(false);
      await loadIslemler();

      const now = new Date();
      now.setMinutes(now.getMinutes() - now.getTimezoneOffset());
      const currentDateTime = now.toISOString().slice(0, 16);

      // Popup reset
      setAltinMaster({
        tarih: currentDateTime,
        islemTur: "",
        aciklama: "",
      });
      setAltinSatirlari([createAltinSatir()]);
    } catch (e) {
      console.error(e);
      alert("Altın kaydı sırasında hata oluştu.");
    }
  };

  /* Popup Form State (Nakit / Ziynet) */
  const [form, setForm] = useState({
    id: null,
    hesapId: Number(hesapId),
    tarih: "",
    islemTur: "",
    birim: "",
    birimDisabled: false,
    miktar: "",
    aciklama: "",
    stokId: null,
    kullaniciId: getUserId(),
  });

  // ==========================
  // FORM KİLİT MANTIĞI
  // - Yeni kayıtta: CREATE yetkisi yeterli
  // - Edit'te: UPDATE yetkisi gerekir
  // ==========================
  const isEdit = editMode && !!form.id;                 // düzenleme modu mu?
  const preventAutoKur = isEdit; // edit modunda kur auto-set YASAK
  const canEditForm = isEdit ? canUpdate : canCreate;   // editte UPDATE, yenide CREATE
  const formDisabled = !canEditForm;                    // form komple kilitli mi?
  const lockHeaderFieldsOnEdit = isEdit;                // editte (isteğe bağlı) bazı alanlar kilitli

  useEffect(() => {
    if (!isNakitPopup) return;

    // EDIT MODU: geçmiş kura dokunma, profil kurunu çekme
    if (preventAutoKur) return;

    // checkbox kapalıysa temizle
    if (!altinKarsiligiMi) {
      setParaBirimiKur("");
      setGuncelKur("");
      return;
    }

    const run = async () => {
      // kur cache yoksa çek (ilk sefer garanti)
      if (!userKurLoaded) {
        await loadUserKurFromProfile();
      }
    };

    run();
  }, [isNakitPopup, altinKarsiligiMi]);


  useEffect(() => {
    if (!isNakitPopup) return;
    if (!altinKarsiligiMi) return;

    // EDIT MODU: birim değişse bile kur auto-set YASAK
    if (preventAutoKur) return;

    const run = async () => {
      // TL seçildiyse para birimi kuru yok → boşaltmak normal
      if (form.birim === "TL") {
        setParaBirimiKur("");
        setFormErrors((p) => ({ ...p, paraBirimiKur: "" }));
        return;
      }

      // Kur yüklenmediyse önce yükle (ilk değişimde boşalmasın diye)
      const kur = userKurLoaded ? userKurCache : await loadUserKurFromProfile();

      // Altın kur: kullanıcı elle dokunmadıysa otomatik bas
      if (!guncelKurTouched) {
        const altin = Number(kur?.altinKur || 0);
        if (altin > 0) {
          setGuncelKur(String(altin));
          setFormErrors((p) => ({ ...p, guncelKur: "" }));
        }
      }

      // USD/EUR kur: kullanıcı elle dokunmadıysa otomatik bas
      if (!paraKurTouched) {
        if (form.birim === "USD") {
          const dolar = Number(kur?.dolarKur || 0);
          if (dolar > 0) {
            setParaBirimiKur(String(dolar));
            setFormErrors((p) => ({ ...p, paraBirimiKur: "" }));
          }
          //  dolar 0 ise ASLA boşaltma → kullanıcı girebilsin
          return;
        }

        if (form.birim === "EUR") {
          const euro = Number(kur?.euroKur || 0);
          if (euro > 0) {
            setParaBirimiKur(String(euro));
            setFormErrors((p) => ({ ...p, paraBirimiKur: "" }));
          }
          // euro 0 ise ASLA boşaltma → kullanıcı girebilsin
          return;
        }
      }
    };

    run();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [form.birim, isNakitPopup, altinKarsiligiMi]);

  /* Butonlara göre stok görünürlüğü */
  const [stokGorunsun, setStokGorunsun] = useState(false);
  const [stokSecimTipi, setStokSecimTipi] = useState(null);

  /* Bakiyeler */
  const [bakiyeTL, setBakiyeTL] = useState(0);
  const [bakiyeUSD, setBakiyeUSD] = useState(0);
  const [bakiyeEUR, setBakiyeEUR] = useState(0);
  const [bakiyeGram, setBakiyeGram] = useState(0);

  // Ziynet bakiyeleri: sabit 6 tür
  const [bakiyeZiynet, setBakiyeZiynet] = useState({
    "Yeni ATA": 0,
    "Yeni YARIM": 0,
    "Yeni ÇEYREK": 0,
    "Eski ATA": 0,
    "Eski YARIM": 0,
    "Eski ÇEYREK": 0,
  });

  const [screenWidth, setScreenWidth] = useState(window.innerWidth);

  // Seçili satırlar (fiş yazdır için)
  const [selectedRows, setSelectedRows] = useState([]);

  /* hesapId değişince formun hesapId'sini setle */
  useEffect(() => {
    if (hesapId) {
      setForm((prev) => ({
        ...prev,
        hesapId: Number(hesapId),
      }));
    }
  }, [hesapId]);

  /* ekran genişliği listener */
  useEffect(() => {
    const handleResize = () => setScreenWidth(window.innerWidth);
    window.addEventListener("resize", handleResize);

    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const loadUserKurFromProfile = async () => {
    try {
      const userId = getUserId();
      if (!userId) return { altinKur: 0, dolarKur: 0, euroKur: 0 };

      const resp = await axiosInstance.get(`/auth/profil/${userId}`);

      const altinKur = Number(resp?.data?.altinKur || 0);
      const dolarKur = Number(resp?.data?.dolarKur || 0);
      const euroKur  = Number(resp?.data?.euroKur  || 0);

      const next = { altinKur, dolarKur, euroKur };

      setUserKurCache(next);
      setUserKurLoaded(true);

      return next;
    } catch (e) {
      console.error("Profil kur çekilemedi:", e);
      return { altinKur: 0, dolarKur: 0, euroKur: 0 };
    }
  };

  const getBaglantiliKur = (birim, kur) => {
    if (birim === "TL") return "";
    if (birim === "USD") return Number(kur?.dolarKur || 0) > 0
      ? String(kur.dolarKur)
      : "";
    if (birim === "EUR") return Number(kur?.euroKur || 0) > 0
      ? String(kur.euroKur)
      : "";
    return "";
  };

  const closeBaglantiliPopup = () => {
    setBaglantiliOpen(false);
    setBaglantiliEditMode(false);
    setBaglantiliErrors({});
    setBaglantiliForm({
      id: null,
      tarih: "",
      islemTur: "NAKIT_BAKIYE_GRAMA_CEVRILDI",
      miktar: "",
      nakitBirim: "TL",
      gramKur: "",
      nakitKur: "",
    });
  };

  const openBaglantiliCreate = async () => {
    if (isLoading) return;
    if (!can(PERM_CREATE)) {
      alert("Bağlantılı işlem ekleme yetkiniz yok.");
      return;
    }

    const kur = userKurLoaded
      ? userKurCache
      : await loadUserKurFromProfile();

    setBaglantiliEditMode(false);
    setBaglantiliErrors({});
    setBaglantiliForm({
      id: null,
      tarih: getLocalDateTime(),
      islemTur: "NAKIT_BAKIYE_GRAMA_CEVRILDI",
      miktar: "",
      nakitBirim: "TL",
      gramKur:
        Number(kur?.altinKur || 0) > 0 ? String(kur.altinKur) : "",
      nakitKur: "",
    });
    setBaglantiliOpen(true);
  };

  const openBaglantiliEdit = (row) => {
    if (!canUpdate) return;

    setBaglantiliEditMode(true);
    setBaglantiliErrors({});
    setBaglantiliForm({
      id: row.id,
      tarih: row.tarih || getLocalDateTime(),
      islemTur: row.islemTur,
      // Nakit -> gramda girilen değer nakit; gram -> nakitte girilen değer gramdır.
      miktar:
        row.islemTur === "NAKIT_BAKIYE_GRAMA_CEVRILDI"
          ? String(row.miktar ?? "")
          : String(row.hasGramToplam ?? ""),
      nakitBirim: row.birim || "TL",
      gramKur: String(row.guncelKur ?? ""),
      nakitKur:
        row.birim === "TL" || Number(row.paraBirimiKur) === 1
          ? ""
          : String(row.paraBirimiKur ?? ""),
    });
    setBaglantiliOpen(true);
  };

  const baglantiliHesaplama = useMemo(() => {
    const miktar = parseDecimalTR(baglantiliForm.miktar);
    const gramKur = parseDecimalTR(baglantiliForm.gramKur);
    const nakitKur =
      baglantiliForm.nakitBirim === "TL"
        ? 1
        : parseDecimalTR(baglantiliForm.nakitKur);

    if (miktar <= 0 || gramKur <= 0 || nakitKur <= 0) {
      return { nakitTutar: 0, gramMiktar: 0 };
    }

    if (baglantiliForm.islemTur === "NAKIT_BAKIYE_GRAMA_CEVRILDI") {
      return {
        nakitTutar: miktar,
        gramMiktar: (miktar * nakitKur) / gramKur,
      };
    }

    return {
      gramMiktar: miktar,
      nakitTutar: (miktar * gramKur) / nakitKur,
    };
  }, [baglantiliForm]);

  const validateBaglantiliForm = () => {
    const errors = {};

    if (!BAGLANTILI_ISLEM_TURLERI.includes(baglantiliForm.islemTur)) {
      errors.islemTur = "İşlem türü zorunludur.";
    }
    if (parseDecimalTR(baglantiliForm.miktar) <= 0) {
      errors.miktar = "Miktar sıfırdan büyük olmalıdır.";
    }
    if (!["TL", "USD", "EUR"].includes(baglantiliForm.nakitBirim)) {
      errors.nakitBirim = "Nakit birim zorunludur.";
    }
    if (parseDecimalTR(baglantiliForm.gramKur) <= 0) {
      errors.gramKur = "Gram kuru sıfırdan büyük olmalıdır.";
    }
    if (
      baglantiliForm.nakitBirim !== "TL" &&
      parseDecimalTR(baglantiliForm.nakitKur) <= 0
    ) {
      errors.nakitKur = `${baglantiliForm.nakitBirim} kuru sıfırdan büyük olmalıdır.`;
    }

    setBaglantiliErrors(errors);
    return Object.keys(errors).length === 0;
  };

  const handleBaglantiliSave = async () => {
    if (baglantiliSaving || isLoading) return;

    const needPerm = baglantiliEditMode ? PERM_UPDATE : PERM_CREATE;
    if (!can(needPerm)) {
      alert("Bu işlem için yetkiniz yok.");
      return;
    }

    if (!validateBaglantiliForm()) return;

    const payload = {
      hesapId: Number(hesapId),
      tarih: baglantiliForm.tarih || getLocalDateTime(),
      islemTur: baglantiliForm.islemTur,
      miktar: parseDecimalTR(baglantiliForm.miktar),
      nakitBirim: baglantiliForm.nakitBirim,
      gramKur: parseDecimalTR(baglantiliForm.gramKur),
      nakitKur:
        baglantiliForm.nakitBirim === "TL"
          ? 1
          : parseDecimalTR(baglantiliForm.nakitKur),
    };

    try {
      setBaglantiliSaving(true);

      if (baglantiliEditMode) {
        await axiosInstance.put(
          `/islemler/baglantili/${baglantiliForm.id}`,
          payload
        );
      } else {
        await axiosInstance.post("/islemler/baglantili", payload);
      }

      closeBaglantiliPopup();
      await loadIslemler();
    } catch (e) {
      console.error("Bağlantılı işlem kaydedilemedi:", e);
      alert(
        e?.response?.data?.message ||
          e?.response?.data ||
          "Bağlantılı işlem kaydedilemedi."
      );
    } finally {
      setBaglantiliSaving(false);
    }
  };

  /* ================= DATA LOAD ================= */
  const loadIslemler = async () => {
    if (isLoading) return;
    if (!can(PERM_VIEW)) {
      setRows([]);
      setFilteredRows([]);
      return;
    }

    try {
      const resp = await axiosInstance.get(`/islemler?hesapId=${hesapId}`);
      setRows(resp.data);
      hesaplaBakiyeler(resp.data);
    } catch (e) {
      console.error("İşlemler alınamadı:", e);
    }
  };

  const loadStoklar = async () => {
    if (isLoading) return;
    if (!can(PERM_VIEW)) {
      setStoklar([]);
      return;
    }

    try {
      const userId = getUserId();
      if (!userId) return;
      const resp = await axiosInstance.get(`/stoklar?userId=${userId}`);
      setStoklar(resp.data || []);
    } catch (e) {
      console.error("Stoklar alınamadı:", e);
    }
  };

  /* Hesap adını çekelim */
  const loadHesapAdi = async () => {
    if (isLoading) return;
    if (!can(PERM_VIEW)) {
      setHesapAdi("");
      return;
    }

    try {
      const userId = getUserId();
      const resp = await axiosInstance.get(`/hesaplar?userId=${userId}`);
      const h = resp.data.find((x) => x.id === Number(hesapId));
      setHesapAdi(h?.hesapAdi || "");
    } catch (e) {
      console.error("Hesap adı alınamadı:", e);
    }
  };

  useEffect(() => {
    if (!hesapId) return;
    if (isLoading) return;

    // VIEW yoksa zaten fonksiyonlar boş dönecek ama net olsun:
    if (!can(PERM_VIEW)) return;

    loadIslemler();
    loadStoklar();
    loadHesapAdi();
  }, [hesapId, isLoading]);

  // Nakit popup açılınca kur bilgilerini yükle
  useEffect(() => {
    if (!open || !isNakitPopup) return;

    if (!userKurLoaded) {
      loadUserKurFromProfile();
    }
  }, [open, isNakitPopup]);


  useEffect(() => {
    // Tarih aralığı yoksa hepsi
    if (!filterStart && !filterEnd) {
      setFilteredRows(rows);
      return;
    }

    const start = filterStart ? toStartOfDay(filterStart) : null;
    const end = filterEnd ? toEndOfDay(filterEnd) : null;

    const out = (rows || []).filter((r) => {
      const t = r?.tarih ? new Date(r.tarih) : null;
      if (!t || isNaN(t.getTime())) return false;

      if (start && t < start) return false;
      if (end && t > end) return false;
      return true;
    });

    setFilteredRows(out);
  }, [rows, filterStart, filterEnd]);


  /* ==========================================================
     BAKİYE HESAPLAMA — YENİ SİSTEM
     Artık BORÇ / ALACAK kolonlarından net değer hesaplıyoruz.
  ========================================================== */
  const hesaplaBakiyeler = (list) => {
    let _tl = 0,
      _usd = 0,
      _eur = 0,
      _gram = 0,
      _yeniAta = 0,
      _yeniYarim = 0,
      _yeniCeyrek = 0,
      _eskiAta = 0,
      _eskiYarim = 0,
      _eskiCeyrek = 0;

    list.forEach((i) => {
      const borc = Number(i.borc || 0);
      const alacak = Number(i.alacak || 0);
      const net = borc - alacak;

      // Bağlantılı işlem aynı anda hem nakit hem gram bakiyesini etkiler.
      if (isBaglantiliIslem(i.islemTur)) {
        if (i.birim === "TL") _tl += net;
        if (i.birim === "USD") _usd += net;
        if (i.birim === "EUR") _eur += net;

        const gramMiktar = Number(i.hasGramToplam || 0);
        _gram +=
          i.islemTur === "NAKIT_BAKIYE_GRAMA_CEVRILDI"
            ? gramMiktar
            : -gramMiktar;
        return;
      }

      // Para ve gram bakiyesi birime göre
      const isAltinKarsiligi =
        i.islemTur === "NAKIT_ISLEM_GRAM_ALINDI" ||
        i.islemTur === "NAKIT_ISLEM_GRAM_VERILDI";

      // ALTIN KARŞILIĞI → TL/USD/EUR bakiyesi DEĞİŞMEZ
      if (!isAltinKarsiligi) {
        if (i.birim === "TL") _tl += net;
        if (i.birim === "USD") _usd += net;
        if (i.birim === "EUR") _eur += net;
      }

      // Altın karşılığı → GRAM bakiyesi artar/azalır
      if (isAltinKarsiligi || i.birim === "GRAM") {
        _gram += net;
      }

      // Ziynet adetleri (borç-alacak üzerinden)
      if (i.islemTur?.includes("ZIYNET")) {
        if (i.stokAdi === "Yeni ATA") _yeniAta += net;
        if (i.stokAdi === "Yeni YARIM") _yeniYarim += net;
        if (i.stokAdi === "Yeni ÇEYREK") _yeniCeyrek += net;
        if (i.stokAdi === "Eski ATA") _eskiAta += net;
        if (i.stokAdi === "Eski YARIM") _eskiYarim += net;
        if (i.stokAdi === "Eski ÇEYREK") _eskiCeyrek += net;
      }
    });

    setBakiyeTL(Number(_tl.toFixed(2)));
    setBakiyeUSD(Number(_usd.toFixed(2)));
    setBakiyeEUR(Number(_eur.toFixed(2)));
    setBakiyeGram(Number(_gram.toFixed(2)));

    setBakiyeZiynet({
      "Yeni ATA": _yeniAta,
      "Yeni YARIM": _yeniYarim,
      "Yeni ÇEYREK": _yeniCeyrek,
      "Eski ATA": _eskiAta,
      "Eski YARIM": _eskiYarim,
      "Eski ÇEYREK": _eskiCeyrek,
    });
  };

    /* ==========================================================
       İŞLEM ANINDA BAKİYE (FRONTEND HESAPLAMA)
       - Filtrelerden bağımsız: rows üzerinden hesaplanır
       - Tarih referansı: grid satırlarının tarih alanı
       - Her satır için "işlem sonrası bakiye" saklanır
    ========================================================== */

    const getEffectiveBakiyeType = (row) => {
      const tur = row?.islemTur || "";

      // Altın karşılığı nakit (NAKIT_ISLEM_GRAM_*) → para değil GRAM bakiyesi etkilenir
      const isAltinKarsiligi =
        tur === "NAKIT_ISLEM_GRAM_ALINDI" || tur === "NAKIT_ISLEM_GRAM_VERILDI";

      // Bağlantılı işlem aynı anda iki bakiye gösterir.
      if (isBaglantiliIslem(tur)) {
        return `BAGLANTILI:${row?.birim || "-"}`;
      }

      // ALTIN_* işlemleri → GRAM bakiyesi
      if (tur.startsWith("ALTIN")) return "GRAM";

      // Ziynet → stok bazında ADET bakiyesi (Yeni ATA/YARIM/ÇEYREK vs.)
      if (tur.startsWith("ZIYNET")) return `ZIYNET:${row?.stokAdi || "-"}`;

      // Altın karşılığı nakit → GRAM
      if (isAltinKarsiligi) return "GRAM";

      // Normal nakit → TL/USD/EUR (row.birim)
      return row?.birim || "-";
    };

    const formatBakiyeForType = (val, type) => {
      if (type.startsWith("BAGLANTILI:")) return "";
      if (val == null || isNaN(Number(val))) return "-";

      // Ziynet sayıları tam sayı gösterilsin
      if (type.startsWith("ZIYNET:")) {
        const n = Math.round(Number(val) || 0);
        return n.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
      }

      // GRAM ve para birimleri: mevcut formatınla uyumlu
      // (formatNumberTR zaten sayfada import ediliyor)
      return formatNumberTR(Number(val), 2);
    };

    const islemAnindaBakiyeMap = useMemo(() => {
      const list = Array.isArray(rows) ? [...rows] : [];

      // Grid tarihine göre sırala (ascending). Eşit tarihte id ile stabil yap.
      list.sort((a, b) => {
        const ta = a?.tarih ? new Date(a.tarih).getTime() : 0;
        const tb = b?.tarih ? new Date(b.tarih).getTime() : 0;
        if (ta !== tb) return ta - tb;
        return (Number(a?.id) || 0) - (Number(b?.id) || 0);
      });

      let tl = 0,
        usd = 0,
        eur = 0,
        gram = 0;

      const ziynet = {
        "Yeni ATA": 0,
        "Yeni YARIM": 0,
        "Yeni ÇEYREK": 0,
        "Eski ATA": 0,
        "Eski YARIM": 0,
        "Eski ÇEYREK": 0,
      };

      const out = {}; // { [id]: { type, value } }

      for (const i of list) {
        const borc = Number(i?.borc || 0);
        const alacak = Number(i?.alacak || 0);
        const net = borc - alacak;

        const tur = i?.islemTur || "";

        if (isBaglantiliIslem(tur)) {
          if (i?.birim === "TL") tl += net;
          if (i?.birim === "USD") usd += net;
          if (i?.birim === "EUR") eur += net;

          const gramMiktar = Number(i?.hasGramToplam || 0);
          gram +=
            tur === "NAKIT_BAKIYE_GRAMA_CEVRILDI"
              ? gramMiktar
              : -gramMiktar;

          const nakitBakiye =
            i?.birim === "TL" ? tl : i?.birim === "USD" ? usd : eur;

          out[i.id] = {
            type: `BAGLANTILI:${i?.birim || "-"}`,
            value: { nakit: nakitBakiye, gram },
          };
          continue;
        }

        const isAltinKarsiligi =
          tur === "NAKIT_ISLEM_GRAM_ALINDI" || tur === "NAKIT_ISLEM_GRAM_VERILDI";

        // 1) Para bakiyeleri: altın karşılığı nakitte değişmez (senin mevcut mantığınla aynı)
        if (!isAltinKarsiligi) {
          if (i?.birim === "TL") tl += net;
          if (i?.birim === "USD") usd += net;
          if (i?.birim === "EUR") eur += net;
        }

        // 2) Gram bakiyesi: ALTIN_* veya altın karşılığı nakit
        if (isAltinKarsiligi || i?.birim === "GRAM" || tur.startsWith("ALTIN")) {
          gram += net;
        }

        // 3) Ziynet: stokAdi bazında net
        if (tur.includes("ZIYNET")) {
          const key = i?.stokAdi;
          if (key && Object.prototype.hasOwnProperty.call(ziynet, key)) {
            ziynet[key] += net;
          }
        }

        // Bu satırın "işlem anında bakiye" değeri:
        const type = getEffectiveBakiyeType(i);
        let value;

        if (type === "TL") value = tl;
        else if (type === "USD") value = usd;
        else if (type === "EUR") value = eur;
        else if (type === "GRAM") value = gram;
        else if (type.startsWith("ZIYNET:")) {
          const stokAdi = type.split("ZIYNET:")[1];
          value = ziynet[stokAdi] ?? 0;
        } else value = null;

        out[i.id] = { type, value };
      }

      return out;
    }, [rows]);


  /* ==========================================================
     3’LÜ BUTON → POPUP AÇILIRKEN FORMU OTOMATİK AYARLA
  ========================================================== */
  const handleOpenPopup = (type) => {
    if (isLoading) return;
    if (!can(PERM_CREATE)) {
      alert("İşlem ekleme yetkiniz yok.");
      return;
    }

    setEditMode(false);

    let newForm = {
      id: null,
      hesapId: Number(hesapId),
      tarih: "",
      islemTur: "",
      birim: "",
      birimDisabled: false,
      miktar: "",
      aciklama: "",
      stokId: null,
      kullaniciId: getUserId(),
    };

    /* --- NAKİT --- */
    if (type === "NAKIT") {
      setIsNakitPopup(true);
      newForm.islemTur = "";
      newForm.birim = "TL";
      newForm.birimDisabled = false;
      newForm.tarih = getLocalDateTime();
      setStokGorunsun(false);
      setStokSecimTipi(null);
      setForm(newForm);
      setOpen(true);
      return;
    }

    /* --- ZİYNET --- */
    if (type === "ZIYNET") {
      setIsNakitPopup(false);
      newForm.islemTur = "";
      newForm.birim = "ADET";
      newForm.birimDisabled = true;
      newForm.tarih = getLocalDateTime();
      setStokGorunsun(true);
      setStokSecimTipi("ZIYNET");
      setForm(newForm);
      setOpen(true);
      return;
    }

    /* --- ALTIN --- → Artık çoklu popup açıyoruz */
    if (type === "ALTIN") {
      setIsNakitPopup(false);
      setAltinMaster({
        tarih: getLocalDateTime(),
        islemTur: "",
        aciklama: "",
      });
      // Satır mutlaka createAltinSatir() ile oluşturulmalı.
      // Aksi halde _rowKey oluşmaz ve handleAltinStokChange çalışmadan çıkar.
      setAltinSatirlari([createAltinSatir()]);
      setOpenAltinPopup(true);
      return;
    }
  };

    const validateForm = () => {
      let errors = {};

      // 1️⃣ Ortak zorunlu alanlar
      if (!form.tarih) {
        errors.tarih = "Tarih zorunludur.";
      }

      if (!form.islemTur) {
        errors.islemTur = "İşlem türü zorunludur.";
      }

      if (!form.birim) {
        errors.birim = "Birim zorunludur.";
      }

      if (!form.miktar || Number(form.miktar) <= 0) {
        errors.miktar = "Miktar zorunludur.";
      }

      // 2️⃣ Ziynet işlemleri → stok zorunlu
      if (stokGorunsun && !form.stokId) {
        errors.stokId = "Stok seçimi zorunludur.";
      }

      // 3️⃣ Altın karşılığı nakit işlemleri
      if (isNakitPopup && altinKarsiligiMi) {
        // Altın kuru (TL / Gram)
        if (!guncelKur || Number(guncelKur) <= 0) {
          errors.guncelKur = "Altın kuru zorunludur.";
        }

        // USD / EUR ise para birimi kuru
        if (
          form.birim !== "TL" &&
          (!paraBirimiKur || Number(paraBirimiKur) <= 0)
        ) {
          errors.paraBirimiKur = "Para birimi kuru zorunludur.";
        }
      }

      setFormErrors(errors);

      // Hiç hata yoksa true
      return Object.keys(errors).length === 0;
    };


  /* ==========================================================
     POPUP - KAYDET (Nakit / Ziynet)
     (ALTIN artık sadece çoklu popup ile kaydediliyor)
  ========================================================== */
    const handleSave = async () => {
      if (isLoading) return;

      const needPerm = editMode ? PERM_UPDATE : PERM_CREATE;
      if (!can(needPerm)) {
        alert("Bu işlem için yetkiniz yok.");
        return;
      }

      try {

        if (!validateForm()) {
          return;
        }

        const userId = getUserId();

        // ===============================
        // 1) ALTIN KARŞILIĞI İŞLEM TÜRLERİ DÖNÜŞÜMÜ
        // ===============================
        let finalIslemTur = form.islemTur;

        if (altinKarsiligiMi) {
          if (form.islemTur === "NAKIT_ALINDI") {
            finalIslemTur = "NAKIT_ISLEM_GRAM_ALINDI";
          }
          if (form.islemTur === "NAKIT_VERILDI") {
            finalIslemTur = "NAKIT_ISLEM_GRAM_VERILDI";
          }
        }

        const stokAdiBul = (id) => {
          const s = stoklar.find((x) => x.id === Number(id));
          return s ? s.stokAdi : null;
        };

        // ===============================
        // 2) PAYLOAD OLUŞTURMA
        // ===============================
        const payload = {
          ...form,
          islemTur: finalIslemTur,     // ← artık doğru tür burada
          kullaniciId: userId,
          stokId: form.stokId ?? null,
          stokAdi: stokAdiBul(form.stokId),
          altinKarsiligiMi: altinKarsiligiMi,
          guncelKur: guncelKur ? Number(guncelKur) : null, // ALTIN KURU
          paraBirimiKur: form.birim === "TL" ? 1 : Number(paraBirimiKur),
          hasGramToplam: hesaplananGram,
        };

        if (editMode) {
          await axiosInstance.put("/islemler", payload);
        } else {
          await axiosInstance.post("/islemler", payload);
        }

        setOpen(false);
        loadIslemler();
        resetForm();
      } catch (e) {
        alert("Kayıt sırasında hata oluştu.");
        console.error(e);
      }
    };

  const resetForm = () => {
    const now = new Date();
    now.setMinutes(now.getMinutes() - now.getTimezoneOffset());
    const currentDateTime = now.toISOString().slice(0, 16);

    setForm({
      id: null,
      hesapId: Number(hesapId),
      tarih: currentDateTime,
      islemTur: "",
      birim: "",
      birimDisabled: false,
      miktar: "",
      aciklama: "",
      stokId: null,
      kullaniciId: getUserId(),
    });

    setAltinKarsiligiMi(false);
    setParaBirimiKur("");
    setGuncelKur("");
    setFormErrors({});
    setIsNakitPopup(false);

    setEditMode(false);
    setStokGorunsun(false);
    setStokSecimTipi(null);
  };

  const handleDelete = async () => {
    if (isLoading) return;

    if (!can(PERM_DELETE)) {
      alert("Silme yetkiniz yok.");
      setSilmePopupOpen(false);
      setSilinecekId(null);
      return;
    }

    try {
      await axiosInstance.delete(`/islemler/${silinecekId}`);
      loadIslemler();
    } catch (e) {
      alert("Silme sırasında hata oluştu.");
    } finally {
      setSilmePopupOpen(false); // uyarı popup kapanır
      setOpen(false);           // ana popup kapanır
      setBaglantiliOpen(false); // bağlantılı işlem popup kapanır
      setSilinecekId(null);
      resetForm();
    }
  };

  /* ==========================================================
     GRİD SATIR CLICK → DÜZENLEME
     ALTIN işlemleri şimdilik burada düzenlenmiyor
     (İleride ayrı "stok satırları" popup'ı açacağız)
  ========================================================== */
  const onRowClick = (params) => {

    if (!canUpdate) {
      // update yetkisi yoksa edit ekranı açma
      return;
    }

    const row = params.row;

    if (isBaglantiliIslem(row.islemTur)) {
      openBaglantiliEdit(row);
      return;
    }

    const isAltin = row.islemTur.includes("ALTIN");
    const isZiynet = row.islemTur.includes("ZIYNET");

    // NAKİT popup mı? (edit için kritik)
    const isNakit =
      row.islemTur.includes("NAKIT");

    setIsNakitPopup(isNakit);

    // ALTIN → yeni detay sayfası
    if (isAltin) {
      navigate(`/KuyumcuHesapIslemAltinDetay/${row.id}`);
      return;
    }

    setStokGorunsun(isZiynet);
    setStokSecimTipi(isZiynet ? "ZIYNET" : null);

    // GRAM türlerini popup'ta "NAKIT_ALINDI / NAKIT_VERILDI" olarak göstermek için dönüşüm
    let uiIslemTur = row.islemTur;

    if (row.islemTur === "NAKIT_ISLEM_GRAM_ALINDI") {
      uiIslemTur = "NAKIT_ALINDI";
    }
    if (row.islemTur === "NAKIT_ISLEM_GRAM_VERILDI") {
      uiIslemTur = "NAKIT_VERILDI";
    }

    // FORM SETLEME
    setForm({
      id: row.id,
      hesapId: row.hesapId,
      tarih: row.tarih,
      islemTur: uiIslemTur,   // ← artık GRAM işlem türleri popup'ta NAKIT olarak görünür
      birim: row.birim,
      birimDisabled: isZiynet,
      miktar: row.miktar,
      aciklama: row.aciklama || "",
      stokId: row.stokId ?? null,
      kullaniciId: getUserId(),
      hasGramToplam: row.hasGramToplam,
    });

    // Checkbox = GRAM işlem mi?
    const isGramIslem =
      row.islemTur === "NAKIT_ISLEM_GRAM_ALINDI" ||
      row.islemTur === "NAKIT_ISLEM_GRAM_VERILDI";

    setAltinKarsiligiMi(isGramIslem);

    // Kur bilgisini setle
    setGuncelKur(row.guncelKur ? row.guncelKur : "");

    setGuncelKurTouched(true);
    setParaKurTouched(true);

    setParaBirimiKur(
      row.paraBirimiKur != null && row.paraBirimiKur !== 1
        ? String(row.paraBirimiKur)
        : ""
    );

    setEditMode(true);
    setOpen(true);
  };

  // tarih format fonksiyonu
  const formatDate = (value, width) => {
    if (!value) return "";

    const date = new Date(value);

    if (width < 600) {
      // 📱 Mobil — SAAT GÖRÜNMEZ, yıl kısaltılmış
      return date.toLocaleDateString("tr-TR", {
        day: "2-digit",
        month: "2-digit",
        year: "2-digit",
      });
    }

    // 💻 Tablet + PC — tarih + saat
    return `${date.toLocaleDateString("tr-TR", {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
    })} ${date.toLocaleTimeString("tr-TR", {
      hour: "2-digit",
      minute: "2-digit",
    })}`;
  };


    const formatSmart = (value, unit) => {
      let num = Number(value);
      if (isNaN(num)) return "0";

      // Ziynet (adet) → tam sayı + binlik nokta
      if (unit === "ADET") {
        return Math.round(num)
          .toString()
          .replace(/\B(?=(\d{3})+(?!\d))/g, ".");
      }

      // Gram → 2 ondalık + binlik nokta
      if (unit === "GRAM") {
        return num
          .toFixed(2)
          .replace(".", ",")
          .replace(/\B(?=(\d{3})+(?!\d))/g, ".");
      }

      // Para (TL, USD, EUR)
      return num
        .toFixed(2)
        .replace(".", ",")
        .replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    };

    const parseSmart = (str) => {
      if (!str) return "";
      return str
        .replace(/\./g, "")  // binlik noktaları sil
        .replace(",", ".");  // ondalığı noktaya çevir
    };


const parseInteger = (str) => {
  if (!str) return "";
  return str.replace(/\./g, ""); // tüm noktaları sil → ham sayı
};


const formatInteger = (value) => {
  if (!value) return "";
  return parseInt(value, 10)
    .toString()
    .replace(/\B(?=(\d{3})+(?!\d))/g, ".");
};





  // Borç / Alacak kolonları — artık direkt DTO alanları
  const getBorc = (row) => {
    return row.borc != null ? row.borc : "";
  };

  const getAlacak = (row) => {
    return row.alacak != null ? row.alacak : "";
  };

  /* ===========================================================
     SATIR SEÇİMİ (CHECKBOX)
  =========================================================== */
  const handleCheckboxChange = (e, id) => {
    e.stopPropagation();
    if (e.target.checked) {
      setSelectedRows((prev) => [...prev, id]);
    } else {
      setSelectedRows((prev) => prev.filter((x) => x !== id));
    }
  };

  const handleSeciliIslemlerFisPrint = async () => {
    await printSelectedFis({
      selectedRows,
      rows,
      bakiyeGram,
      bakiyeTL,
      bakiyeUSD,
      bakiyeEUR,
    });
  };

    const handlePopupFisPrint = async () => {
      if (!form?.id) {
        alert("Yazdırılacak işlem bulunamadı.");
        return;
      }

      const tekSeciliListe = [form.id];

      // İstersen popup açıldığında checkbox seçimleri de gerçekten temizlenmiş gibi görünsün
      setSelectedRows(tekSeciliListe);

      await printSelectedFis({
        selectedRows: tekSeciliListe,
        rows,
        bakiyeGram,
        bakiyeTL,
        bakiyeUSD,
        bakiyeEUR,
      });
    };

  const handleExcelDownload = () => {
    downloadHesapExcel({
      allRows: rows,
      filteredRows,
      hesapAdi,
      filterStart,
      filterEnd,
    });
  };

  const handleWordDownload = () => {
    downloadHesapWord({
      allRows: rows,
      filteredRows,
      hesapAdi,
      filterStart,
      filterEnd,
    });
  };


  /* ===========================================================
       Kolonları responsive ayarla (başta checkbox kolonu)
    =========================================================== */
  const checkboxColumn = {
    field: "sec",
    headerName: "",
    width: 45,
    sortable: false,
    filterable: false,
    disableColumnMenu: true,
    align: "center",
    headerAlign: "center",
    renderCell: (params) => (
      <div
        style={{
          width: "100%",
          height: "100%",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
        onClick={(e) => e.stopPropagation()}
      >
        <input
          type="checkbox"
          checked={selectedRows.includes(params.row.id)}
          onChange={(e) => handleCheckboxChange(e, params.row.id)}
          onClick={(e) => e.stopPropagation()}
          style={{
            width: "50%",
            height: "40%",
            transform: "scale(1.6)", // görsel büyütme
            transformOrigin: "center",
            cursor: "pointer",
          }}
        />
      </div>
    ),
  };

  const islemAnindaBakiyeColumn = {
    field: "islemAnindaBakiye",
    headerName: "Bakiye",


     // ⬇⬇⬇ GENİŞLİK KONTROLÜ BURADA
      minWidth: screenWidth < 600 ? 110 : 180,
      width: screenWidth < 600 ? 120 : 200,
      flex: screenWidth < 600 ? 0 : 1.2,
      // ⬆⬆⬆

    sortable: false,
    filterable: false,
    renderCell: (p) => {
      const rec = islemAnindaBakiyeMap?.[p.row.id];
      if (!rec) return "-";

      if (rec.type.startsWith("BAGLANTILI:")) {
        const birim = rec.type.split("BAGLANTILI:")[1] || "";
        const nakit = Number(rec.value?.nakit || 0);
        const gram = Number(rec.value?.gram || 0);

        return (
          <Box sx={{ lineHeight: 1.15, textAlign: "center" }}>
            <div style={{ fontWeight: 700 }}>
              {formatNumberTR(nakit, 2)} {birim}
            </div>
            <div style={{ fontSize: 12, opacity: 0.78 }}>
              {formatNumberTR(gram, 3)} GR
            </div>
          </Box>
        );
      }

      const valueNum = Number(rec.value);
      const text = formatBakiyeForType(rec.value, rec.type);

      let color = "#6b7280"; // gri (0 için)
      if (valueNum > 0) color = "#2e7d32";     // yeşil
      else if (valueNum < 0) color = "#c62828"; // kırmızı

      // İstersen birimi küçük yazalım (çok kalabalık olmasın diye sade tuttum):
      // - TL/USD/EUR/GRAM
      // - Ziynet ise stok kısaltması
      let suffix = "";
      if (rec.type === "TL" || rec.type === "USD" || rec.type === "EUR") {
        suffix = ` ${rec.type}`;
      } else if (rec.type.startsWith("ZIYNET:")) {
        const stokAdi = rec.type.split("ZIYNET:")[1] || "";
        const short = ziynetShortMap[stokAdi] ? ` (${ziynetShortMap[stokAdi]})` : "";
        suffix = ` ${short}`;
      } else if(rec.type === "GRAM"){
        suffix =' GR';
      }

      return (
          <span
            style={{
              fontWeight: 700,
              color,
              whiteSpace: "nowrap",
            }}
          >
            {text}
            <span style={{ fontWeight: 400, opacity: 0.75 }}>{suffix}</span>
          </span>
        );
    },
  };

  const renderMutabikButton = (params) => {
    const isMutabik = Boolean(params.row.mutabikMi);
    const isLoading = loadingIds.includes(params.row.id);

    return (
      <button
        disabled={isLoading || !canUpdate}
        className={`mutabik-btn ${isMutabik ? "yes" : "no"}`}
        onClick={async (e) => {
          e.stopPropagation();
          if (!canUpdate) return;

          setLoadingIds((prev) => [...prev, params.row.id]);

          try {
            await axiosInstance.patch(
              `/islemler/${params.row.id}/mutabik`,
              null,
              { params: { value: !isMutabik } }
            );

            setRows((prev) =>
              prev.map((r) =>
                r.id === params.row.id
                  ? { ...r, mutabikMi: !isMutabik }
                  : r
              )
            );
          } catch {
            alert("Mutabakat güncellenemedi");
          } finally {
            setLoadingIds((prev) =>
              prev.filter((x) => x !== params.row.id)
            );
          }
        }}
      >
        {isLoading ? "..." : isMutabik ? "EVET" : "HAYIR"}
      </button>
    );
  };

  let columns = [];

  /* === 📱 400px altı mini mobil === */
  if (screenWidth < 400) {
    columns = [
      checkboxColumn,

      {
        field: "tarih",
        headerName: "Tarih",
        width: 85,
        renderCell: (p) => formatDate(p.row.tarih, screenWidth),
        headerAlign: "center",
        align: "center",
      },

      {
        field: "islemTur",
        headerName: "Tür",
        width: 105,
        renderCell: (p) => formatIslemTurWithZiynet(p.row),
        headerAlign: "center",
        align: "center",
      },

      {
        field: "borc",
        headerName: "Verilen",
        width: 90,
        renderCell: (p) => formatSmart(p.row.borc, p.row.birim),
        headerAlign: "center",
        align: "center",
      },

      {
        field: "alacak",
        headerName: "Alınan",
        width: 90,
        renderCell: (p) => formatSmart(p.row.alacak, p.row.birim),
        headerAlign: "center",
        align: "center",
      },

      {
        field: "birim",
        headerName: "Birim",
        minWidth: 60,
        maxWidth: 60,
        flex: 1,
        headerAlign: "center",
        align: "center",
        renderCell: (p) => {
            const tur = p.row.islemTur;

            if (tur === "NAKIT_ISLEM_GRAM_ALINDI" || tur === "NAKIT_ISLEM_GRAM_VERILDI") {
              return "GRAM";
            }

            return p.row.birim;
        }
      },
      {
        field: "mutabikMi",
        headerName: "Mutabık",
        width: 120,
        sortable: false,
        filterable: false,
        align: "center",
        headerAlign: "center",
        renderCell: renderMutabikButton,
      },

    ];
  }

  /* === 📱 400–600px Mobil / Küçük Tablet === */
  else if (screenWidth < 600) {
    columns = [
      checkboxColumn,

      {
        field: "tarih",
        headerName: "Tarih",
        width: 75,
        renderCell: (p) => formatDate(p.row.tarih, screenWidth),
        headerAlign: "center",
        align: "center",
      },

      {
        field: "islemTur",
        headerName: "Tür",
        width: 150,
        renderCell: (p) => formatIslemTurWithZiynet(p.row),
        headerAlign: "center",
        align: "center",
      },

      {
        field: "borc",
        headerName: "Verilen",
        width: 90,
        renderCell: (p) => formatSmart(p.row.borc, p.row.birim),
        headerAlign: "center",
        align: "center",
      },

      {
        field: "alacak",
        headerName: "Alınan",
        width: 90,
        renderCell: (p) => formatSmart(p.row.alacak, p.row.birim),
        headerAlign: "center",
        align: "center",
      },

      {
        field: "birim",
        headerName: "Birim",
        minWidth: 60,
        maxWidth: 60,
        flex: 1,
        headerAlign: "center",
        align: "center",
        renderCell: (p) => {
            const tur = p.row.islemTur;

            if (tur === "NAKIT_ISLEM_GRAM_ALINDI" || tur === "NAKIT_ISLEM_GRAM_VERILDI") {
              return "GRAM";
            }

            return p.row.birim;
        }
      },

      islemAnindaBakiyeColumn,

      {
        field: "mutabikMi",
        headerName: "Mutabık",
        width: 120,
        sortable: false,
        filterable: false,
        align: "center",
        headerAlign: "center",
        renderCell: renderMutabikButton,
      },

    ];
  }

  /* === 💻 Tablet + PC === */
  else {
    columns = [
      checkboxColumn,

      {
        field: "tarih",
        headerName: "Tarih",
        flex: 1,
        minWidth: 140,
        renderCell: (p) => formatDate(p.row.tarih, screenWidth),
        headerAlign: "center",
        align: "center",
      },

      {
        field: "islemTur",
        headerName: "Tür",
        flex: 1,
        minWidth: 130,
        renderCell: (p) => formatIslemTurWithZiynet(p.row),
        headerAlign: "center",
        align: "center",
      },

      {
        field: "borc",
        headerName: "Verilen",
        flex: 1,
        minWidth: 120,
        renderCell: (p) => formatSmart(p.row.borc, p.row.birim),
        headerAlign: "center",
        align: "center",
      },

      {
        field: "alacak",
        headerName: "Alınan",
        flex: 1,
        minWidth: 120,
        renderCell: (p) => formatSmart(p.row.alacak, p.row.birim),
        headerAlign: "center",
        align: "center",
      },

      {
        field: "birim",
        headerName: "Birim",
        minWidth: 60,
        maxWidth: 60,
        flex: 1,
        headerAlign: "center",
        align: "center",
        renderCell: (p) => {
            const tur = p.row.islemTur;

            if (tur === "NAKIT_ISLEM_GRAM_ALINDI" || tur === "NAKIT_ISLEM_GRAM_VERILDI") {
              return "GRAM";
            }

            return p.row.birim;
        }
      },

      islemAnindaBakiyeColumn,

      {
        field: "aciklama",
        headerName: "Açıklama",
        flex: 2,
        minWidth: 200,
        headerAlign: "center",
        align: "center",
      },

      {
        field: "mutabikMi",
        headerName: "Mutabık",
        width: 120,
        sortable: false,
        filterable: false,
        align: "center",
        headerAlign: "center",
        renderCell: renderMutabikButton,
      },

    ];
  }

  /* ==========================================================
     ALTIN KARŞILIĞI HESAPLAMALAR (TEK KAYNAK)
  ========================================================== */
  const paraKur =
    form.birim === "TL"
      ? 1
      : Number(paraBirimiKur || 0);

  const hesaplananGram =
    form.miktar &&
    guncelKur &&
    (form.birim === "TL" || paraKur > 0)
      ? Number(
          ((Number(form.miktar) * paraKur) / Number(guncelKur)).toFixed(2)
        )
      : null;

  /* ===========================================================
     UI
  =========================================================== */
  return (
    <div className="main-container">

{/*       <PremiumBackground /> */}
      <KuyumcuLeftSideNavbar />

      <div className="content">
        <ProsetBackButton label="Geri Dön" />
        <h1 style={{ color: "#b8860b", marginBottom: 10 }}>{hesapAdi}</h1>

        {/* BAKİYELER KISMI */}
        <Box className="bakiye-container">
          <div className="bakiye-row">
            <div className="bakiye-box">
              <label>Altın (Gram)</label>
              <div className="bakiye-input">
                🪙 <input readOnly value={formatSmart(bakiyeGram, "GRAM")} />
              </div>
            </div>

            <div className="bakiye-box">
              <label>TL</label>
              <div className="bakiye-input">
                ₺ <input readOnly value={formatSmart(bakiyeTL, "TL")} />
              </div>
            </div>

            <div className="bakiye-box">
              <label>USD</label>
              <div className="bakiye-input">
                💵 <input readOnly value={formatSmart(bakiyeUSD, "USD")} />
              </div>
            </div>

            <div className="bakiye-box">
              <label>EUR</label>
              <div className="bakiye-input">
                💶 <input readOnly value={formatSmart(bakiyeEUR, "EUR")} />
              </div>
            </div>
          </div>

          {/* ZİYNET BÖLÜMÜ */}
          <div className="ziynet-panel">
            <h3>Ziynet Bakiye</h3>

            <div className="ziynet-grid">
              {Object.keys(bakiyeZiynet).map((z) => (
                <div className="ziynet-box" key={z}>
                  <label>{z}</label>
                  <input readOnly value={formatSmart(bakiyeZiynet[z], "ADET")} />
                </div>
              ))}
            </div>
          </div>
        </Box>

        {/* =====================================================
            ÜÇLÜ İŞLEM BUTONU
        ===================================================== */}
        <Box
          display="flex"
          justifyContent="center"
          gap={2}
          flexWrap="wrap"
          mt={2}
          mb={1}
        >


        {/* ALTIN İŞLEM EKLE BUTONU → ÇOKLU POPUP */}
          {canCreate && (
          <Button
          startIcon={<AddCircleOutlineIcon />}
            variant="contained"
            sx={{ background: "#b8860b", "&:hover": { background: "#d4a017" } }}
            onClick={() => handleOpenPopup("ALTIN")}
          >
             Altın İşlem Ekle
          </Button>
          )}

          {canCreate && (
          <Button
            variant="contained"
            startIcon={<PaymentsIcon />}
            sx={{ background: "#b8860b", "&:hover": { background: "#d4a017" } }}
            onClick={() => handleOpenPopup("NAKIT")}
          >
            Nakit İşlem Ekle
          </Button>
          )}

          {canCreate && (
          <Button
            variant="contained"
            sx={{ background: "#b8860b", "&:hover": { background: "#d4a017" } }}
            onClick={() => handleOpenPopup("ZIYNET")}
          >
           🪙 Ziynet İşlem Ekle
          </Button>
          )}

          {canCreate && (
            <Button
              variant="contained"
              startIcon={<SwapHorizIcon />}
              sx={{ background: "#8b6508", "&:hover": { background: "#a07408" } }}
              onClick={openBaglantiliCreate}
            >
              Bağlantılı İşlem Ekle
            </Button>
          )}

        {/* SEÇİLİ İŞLEMLER FİŞ YAZDIR */}
          <Button
            variant="contained"
            startIcon={<PrintIcon />}
            sx={{
              backgroundColor: "#2E8B57",
              borderColor: "#009E60",
              color: "white",
              "&:hover": { borderColor: "#d4a017", backgroundColor: "#12a37c" },
            }}
            onClick={handleSeciliIslemlerFisPrint}
          >
            Seçili Fiş Yazdır
          </Button>


        </Box>



        {/* ------------------------------------ */}
        {/*          TARİH VE FİLTRELER          */}
        {/* ------------------------------------ */}
        <Box
          mt={2}
          mb={2}
          display="flex"
          gap={1.5}
          flexWrap="wrap"
          alignItems="center"
          sx={{
            background: "rgba(255,255,255,0.5)",
            padding: "12px 15px",
            borderRadius: "12px",
            backdropFilter: "blur(6px)",
            border: "1px solid rgba(184,134,11,0.3)",
          }}
        >
          <TextField
            type="date"
            label="Başlangıç"
            InputLabelProps={{ shrink: true }}
            value={filterStart}
            onChange={(e) => {
              setPreset("CUSTOM");
              setFilterStart(e.target.value);
            }}
            sx={{
              minWidth: 150,
              "& .MuiOutlinedInput-root": { borderRadius: "10px" },
            }}
          />

          <TextField
            type="date"
            label="Bitiş"
            InputLabelProps={{ shrink: true }}
            value={filterEnd}
            onChange={(e) => {
              setPreset("CUSTOM");
              setFilterEnd(e.target.value);
            }}
            sx={{
              minWidth: 150,
              "& .MuiOutlinedInput-root": { borderRadius: "10px" },
            }}
          />

          {[
            { key: "TODAY", label: "Bugün" },
            { key: "LAST7", label: "Son 7 Gün" },
            { key: "LAST30", label: "Son 30 Gün" },
            { key: "PREV_MONTH", label: "Geçen Ay" },
            { key: "ALL", label: "Tüm Zamanlar" },
          ].map((btn) => (
            <Button
              key={btn.key}
              variant="outlined"
              onClick={() => {
                setPreset(btn.key);
                applyPreset(btn.key);
              }}
              sx={{
                padding: "6px 14px",
                borderRadius: "20px",
                fontWeight: 600,
                fontSize: "0.85rem",
                textTransform: "none",
                border: preset === btn.key ? "2px solid #b8860b" : "1px solid #b8860b",
                color: preset === btn.key ? "#fff" : "#b8860b",
                background: preset === btn.key ? "#edbe4a" : "transparent",
                boxShadow: preset === btn.key ? "0 0 8px rgba(184,134,11,0.6)" : "none",
                transition: "0.25s",
                "&:hover": {
                  background: preset === btn.key ? "#d4a017" : "rgba(184,134,11,0.15)",
                  borderColor: "#d4a017",
                  color: preset === btn.key ? "#fff" : "#d4a017",
                },
              }}
            >
              {btn.label}
            </Button>
          ))}
        </Box>


        {/* GRID */}
        <div style={{ height: 545 }}>
          <ProsetDataGrid
            rows={filteredRows}
            columns={columns}
            pageSize={7}
            onRowClick={onRowClick}
          />

          <Box
            mt={2}
            mb={3}
            display="flex"
            gap={2}
            justifyContent="flex-end"
            width="100%"
          >
            <Button
              variant="contained"
              startIcon={<TableViewIcon />}
              onClick={handleExcelDownload}
              sx={{
                background: "#1e7d44",
                "&:hover": { background: "#23984f" },
                textTransform: "none",
                fontWeight: "bold",
                paddingX: 2,
                paddingY: "6px",
                borderRadius: "8px",
                color: "white",
              }}
            >
              Excel Rapor
            </Button>

            <Button
              variant="contained"
              startIcon={<DescriptionIcon />}
              onClick={handleWordDownload}
              sx={{
                background: "#1e7d44",
                "&:hover": { background: "#23984f" },
                textTransform: "none",
                fontWeight: "bold",
                paddingX: 2,
                paddingY: "6px",
                borderRadius: "8px",
                color: "white",
              }}
            >
                Word Rapor
              </Button>
          </Box>



        </div>

        {/* ===========================================================
             ALTIN ÇOKLU SATIR POPUP (YENİ MİMARİ)
        =========================================================== */}
        <Dialog
          open={openAltinPopup}
          onClose={() => setOpenAltinPopup(false)}
          fullWidth
          maxWidth="md"
        >
          <DialogTitle className="altin-header-title">
            Altın Çoklu İşlem Ekle
          </DialogTitle>

          <DialogContent dividers>
            <div className="altin-popup">
              {/* ---- ÜST MASTER FORM ---- */}
              <div className="altin-master-row">
                <div className="altin-input">
                  <label>Tarih</label>
                  <input
                    type="datetime-local"
                    value={altinMaster.tarih}
                    onChange={(e) =>
                      setAltinMaster({ ...altinMaster, tarih: e.target.value })
                    }
                  />
                </div>

                <KuyumcuDropBox
                  label="İşlem Türü"
                  value={altinMaster.islemTur}
                  onChange={handleAltinIslemTurChange}
                  options={[
                    { value: "ALTIN_ALINDI", label: "Altın Alındı" },
                    { value: "ALTIN_VERILDI", label: "Altın Verildi" },
                  ]}
                />

                <div className="altin-input">
                  <label>Açıklama</label>
                  <input
                    type="text"
                    value={altinMaster.aciklama}
                    onChange={(e) =>
                      setAltinMaster({
                        ...altinMaster,
                        aciklama: e.target.value,
                      })
                    }
                  />
                </div>
              </div>

              <Button
                variant="contained"
                startIcon={<AddIcon />}
                sx={{ background: "#b8860b", mt: 2 }}
                onClick={addRow}
              >
                Satır Ekle
              </Button>

              {/* ---- SATIRLAR ---- */}
              {altinSatirlari.map((row, index) => (
                <div className="altin-row-box" key={row._rowKey}>
                  {/* ÜST GRİD */}
                  <div className="altin-row-grid">
                    <KuyumcuDropBox
                      label="Stok"
                      value={row.stokId}
                      onChange={(val) =>
                        handleAltinStokChange(index, val)
                      }
                      options={stoklar
                        .filter((s) => !s.sabitMi)
                        .map((s) => ({ value: s.id, label: s.stokAdi }))}
                    ></KuyumcuDropBox>

                    <div className="altin-input">
                      <label>Miktar</label>
                      <input
                        type="number"
                        value={row.miktar}
                        onChange={(e) =>
                          handleRowChange(index, "miktar", e.target.value)
                        }
                      />
                    </div>

                    <div className="altin-input">
                      <label>Milyem</label>
                      <input
                        type="number"
                        value={row.milyem}
                        onChange={(e) =>
                          handleRowChange(index, "milyem", e.target.value)
                        }
                      />
                    </div>

                    <div className="altin-input">
                      <label>Has Gram</label>
                      <input type="text" value={row.hasGram} disabled />
                    </div>
                  </div>

                  {/* ALT GRİD */}
                  <div className="altin-row-grid">
                    <div className="altin-input">
                      <label>Adet</label>
                      <input
                        type="number"
                        value={row.adet}
                        onChange={(e) =>
                          handleRowChange(index, "adet", e.target.value)
                        }
                      />
                    </div>

                    <div className="altin-input">
                      <label>İşçilik</label>
                      <input
                        type="number"
                        value={row.iscilik}
                        onChange={(e) =>
                          handleRowChange(
                            index,
                            "iscilik",
                            e.target.value,
                            true
                          )
                        }
                      />
                    </div>

                    <div className="altin-input">
                      <label>İşçilik Gr</label>
                      <input type="text" value={row.iscilikGram} disabled />

                    </div>

                    {altinMaster.islemTur === "ALTIN_VERILDI" && (
                    <div className="altin-input">
                      <label>İşçilik Maliyet (Opsiyonel)</label>
                      <input style={{ backgroundColor: "#D3B000" }}
                       type="number"
                       value={row.alinanIscilik}
                       onChange={(e) =>
                           handleRowChange(index, "alinanIscilik", e.target.value)
                       }
                       />

                    </div>
                    )}

                    {altinMaster.islemTur === "ALTIN_ALINDI" && (
                    <div className="altin-input">
                      <label>İşçilik (İade Durumu)</label>
                      <input style={{ backgroundColor: "#D3B000" }}
                       type="number"
                       value={row.verilenIscilik}
                       onChange={(e) =>
                           handleRowChange(index, "verilenIscilik", e.target.value)
                       }
                       />

                    </div>
                    )}

                    <button
                      className="altin-delete-btn"
                      onClick={() => removeRow(index)}
                    >
                      - SATIR SİL
                    </button>
                  </div>
                </div>
              ))}
            </div>
          </DialogContent>

          <DialogActions>
            <Button
              style = {{backgroundColor: "#808080"}}
              variant="contained"
              startIcon={<CloseIcon />}
              onClick={() => setOpenAltinPopup(false)}
            >
              Vazgeç
            </Button>

            <Button
              startIcon={<SaveIcon />}
              onClick={handleAltinTopluKaydet}
              variant="contained"
            >
              Kaydet
            </Button>
          </DialogActions>
        </Dialog>

        {/* =====================================================
            BAĞLANTILI İŞLEM POPUP
        ===================================================== */}
        <Dialog
          open={baglantiliOpen}
          onClose={closeBaglantiliPopup}
          fullWidth
          maxWidth="sm"
          PaperProps={{ sx: { borderRadius: "16px" } }}
        >
          <DialogTitle
            sx={{ textAlign: "center", fontWeight: 700, color: "#b8860b" }}
          >
            Bağlantılı İşlem Ekle
          </DialogTitle>

          <DialogContent
            dividers
            sx={{
              pt: 2,
              "& .MuiFormControl-root": { mb: 2 },
            }}
          >
            <TextField
              select
              fullWidth
              label="İşlem Türü"
              value={baglantiliForm.islemTur}
              onChange={(e) => {
                setBaglantiliForm((p) => ({ ...p, islemTur: e.target.value }));
                setBaglantiliErrors((p) => ({ ...p, islemTur: "" }));
              }}
              error={!!baglantiliErrors.islemTur}
              helperText={baglantiliErrors.islemTur}
            >
              <MenuItem value="NAKIT_BAKIYE_GRAMA_CEVRILDI">
                Nakit Bakiyeyi Grama Çevir
              </MenuItem>
              <MenuItem value="GRAM_BAKIYE_NAKITE_CEVRILDI">
                Gram Bakiyeyi Nakite Çevir
              </MenuItem>
            </TextField>

            <TextField
              fullWidth
              label={
                baglantiliForm.islemTur === "NAKIT_BAKIYE_GRAMA_CEVRILDI"
                  ? "Miktar (Nakit)"
                  : "Miktar (Gram)"
              }
              placeholder="Örn: 1000,50"
              value={baglantiliForm.miktar}
              onChange={(e) => {
                const value = e.target.value.replace(/[^0-9.,]/g, "");
                setBaglantiliForm((p) => ({ ...p, miktar: value }));
                setBaglantiliErrors((p) => ({ ...p, miktar: "" }));
              }}
              error={!!baglantiliErrors.miktar}
              helperText={baglantiliErrors.miktar}
              inputProps={{ inputMode: "decimal" }}
            />

            <TextField
              select
              fullWidth
              label="Nakit Birim"
              value={baglantiliForm.nakitBirim}
              onChange={async (e) => {
                const birim = e.target.value;
                const kur = userKurLoaded
                  ? userKurCache
                  : await loadUserKurFromProfile();

                setBaglantiliForm((p) => ({
                  ...p,
                  nakitBirim: birim,
                  nakitKur: getBaglantiliKur(birim, kur),
                }));
                setBaglantiliErrors((p) => ({
                  ...p,
                  nakitBirim: "",
                  nakitKur: "",
                }));
              }}
              error={!!baglantiliErrors.nakitBirim}
              helperText={baglantiliErrors.nakitBirim}
            >
              <MenuItem value="TL">TL</MenuItem>
              <MenuItem value="USD">USD</MenuItem>
              <MenuItem value="EUR">EUR</MenuItem>
            </TextField>

            <TextField
              fullWidth
              label="Kur (Gram)"
              placeholder="Örn: 5000,00"
              value={baglantiliForm.gramKur}
              onChange={(e) => {
                const value = e.target.value.replace(/[^0-9.,]/g, "");
                setBaglantiliForm((p) => ({ ...p, gramKur: value }));
                setBaglantiliErrors((p) => ({ ...p, gramKur: "" }));
              }}
              error={!!baglantiliErrors.gramKur}
              helperText={baglantiliErrors.gramKur}
              inputProps={{ inputMode: "decimal" }}
            />

            {baglantiliForm.nakitBirim !== "TL" && (
              <TextField
                fullWidth
                label={`Kur (${baglantiliForm.nakitBirim})`}
                placeholder="Örn: 50,00"
                value={baglantiliForm.nakitKur}
                onChange={(e) => {
                  const value = e.target.value.replace(/[^0-9.,]/g, "");
                  setBaglantiliForm((p) => ({ ...p, nakitKur: value }));
                  setBaglantiliErrors((p) => ({ ...p, nakitKur: "" }));
                }}
                error={!!baglantiliErrors.nakitKur}
                helperText={baglantiliErrors.nakitKur}
                inputProps={{ inputMode: "decimal" }}
              />
            )}

            <Box
              sx={{
                mt: 1,
                p: 1.5,
                borderRadius: 2,
                background: "#fff8e1",
                border: "1px solid rgba(184,134,11,0.30)",
                textAlign: "center",
              }}
            >
              {baglantiliForm.islemTur === "NAKIT_BAKIYE_GRAMA_CEVRILDI" ? (
                <>
                  <strong>Düşecek Nakit :</strong>{" "}
                  {formatNumberTR(baglantiliHesaplama.nakitTutar, 2)}{" "}
                  {baglantiliForm.nakitBirim}
                  <br />
                  <strong>Artacak Gram :</strong>{" "}
                  {formatNumberTR(baglantiliHesaplama.gramMiktar, 2)} GR
                </>
              ) : (
                <>
                  <strong>Düşecek Gram :</strong>{" "}
                  {formatNumberTR(baglantiliHesaplama.gramMiktar, 2)} GR
                  <br />
                  <strong>Artacak Nakit :</strong>{" "}
                  {formatNumberTR(baglantiliHesaplama.nakitTutar, 2)}{" "}
                  {baglantiliForm.nakitBirim}
                </>
              )}
            </Box>
          </DialogContent>

          <DialogActions sx={{ justifyContent: "center", gap: 2, py: 2 }}>
            {baglantiliEditMode && canDelete && (
              <Button
                onClick={() => {
                  setSilinecekId(baglantiliForm.id);
                  setSilmePopupOpen(true);
                }}
                sx={{
                  background: "#c62828",
                  color: "#fff",
                  "&:hover": { background: "#8e0000" },
                }}
              >
                Sil
              </Button>
            )}

            <Button
              onClick={closeBaglantiliPopup}
              sx={{
                background: "#666",
                color: "#fff",
                "&:hover": { background: "#444" },
              }}
            >
              Vazgeç
            </Button>

            <Button
              disabled={baglantiliSaving}
              onClick={handleBaglantiliSave}
              sx={{
                background: "#b8860b",
                color: "#fff",
                "&:hover": { background: "#d4a017" },
              }}
            >
              Kaydet
            </Button>
          </DialogActions>
        </Dialog>

        {/* =====================================================
            GENEL POPUP (NAKİT / ZİYNET)
        ===================================================== */}
        <ProsetPopup
          open={open}
          title={editMode ? "İşlem Düzenle" : "Yeni İşlem"}
          editMode={editMode}
          onSave={handleSave}
          onCancel={() => {
            resetForm();
            setOpen(false);
          }}
          onDelete={() => {
              setSilinecekId(form.id);
              setSilmePopupOpen(true);
            }}
          extraActions={
            editMode ? (
              <Button
                variant="contained"
                startIcon={<PrintIcon />}
                onClick={handlePopupFisPrint}
                sx={{
                  backgroundColor: "#b8860b",
                  color: "white",
                  textTransform: "none",
                  fontWeight: 600,
                  "&:hover": { backgroundColor: "#d4a017" },
                }}
              >
                Fiş Yazdır
              </Button>
            ) : null
          }
        >
{/*         <PremiumBackground /> */}
          {/* =========================
              TARİH
          ========================= */}
          <TextField
            disabled={formDisabled}
            type="datetime-local"
            fullWidth
            label="Tarih"
            InputLabelProps={{ shrink: true }}
            value={form.tarih}
            onChange={(e) => {
              setForm({ ...form, tarih: e.target.value });
              setFormErrors((p) => ({ ...p, tarih: "" }));
            }}
            error={!!formErrors.tarih}
            helperText={formErrors.tarih}
          />

          {/* =========================
              İŞLEM TÜRÜ
          ========================= */}
          <TextField
            disabled={formDisabled}
            select
            fullWidth
            label="İşlem Türü"
            value={form.islemTur}
            onChange={(e) => {
              setForm({ ...form, islemTur: e.target.value });
              setFormErrors((p) => ({ ...p, islemTur: "" }));
            }}
            error={!!formErrors.islemTur}
            helperText={formErrors.islemTur}
          >
            {islemTurleri[stokSecimTipi || "NAKIT"].map((t) => (
              <MenuItem key={t} value={t}>
                {t.replace("_", " ")}
              </MenuItem>
            ))}
          </TextField>

          {/* =========================
              ZİYNET → STOK
          ========================= */}
          {stokGorunsun && (
            <TextField
              disabled={formDisabled}
              select
              fullWidth
              label="Stok Seç"
              value={form.stokId ?? ""}
              onChange={(e) => {
                setForm({ ...form, stokId: Number(e.target.value) });
                setFormErrors((p) => ({ ...p, stokId: "" }));
              }}
              error={!!formErrors.stokId}
              helperText={formErrors.stokId}
            >
              {stoklar
                .filter((s) => s.sabitMi)
                .map((s) => (
                  <MenuItem key={s.id} value={s.id}>
                    {s.stokAdi} ({s.birim})
                  </MenuItem>
                ))}
            </TextField>
          )}

          {/* =========================
              BİRİM
          ========================= */}
          {!form.birimDisabled ? (
            <TextField
              disabled={formDisabled}
              select
              fullWidth
              label="Birim"
              value={form.birim}
              onChange={(e) => {
                setForm({ ...form, birim: e.target.value });
                setParaKurTouched(false); // yeni birime geçince default kur yazabilsin
              }}
              error={!!formErrors.birim}
              helperText={formErrors.birim}
            >
              <MenuItem value="TL">TL</MenuItem>
              <MenuItem value="USD">USD</MenuItem>
              <MenuItem value="EUR">EUR</MenuItem>
            </TextField>
          ) : (
            <TextField fullWidth label="Birim" disabled value={form.birim} />
          )}

          {/* =========================
              MİKTAR
          ========================= */}
          <TextField
            disabled={formDisabled}
            fullWidth
            label="Miktar"
            type="text"
            value={formatInteger(form.miktar)}
            onChange={(e) => {
              const raw = e.target.value.replace(/\D/g, "");
              setForm({ ...form, miktar: raw });
              setFormErrors((p) => ({ ...p, miktar: "" }));
            }}
            error={!!formErrors.miktar}
            helperText={formErrors.miktar}
          />

          {/* =========================
              AÇIKLAMA
          ========================= */}
          <TextField
            disabled={formDisabled}
            fullWidth
            label="Açıklama"
            value={form.aciklama}
            onChange={(e) => setForm({ ...form, aciklama: e.target.value })}
          />

          {/* =========================
              ALTIN KARŞILIĞI CHECKBOX
          ========================= */}
          {isNakitPopup && (
            <div style={{ marginTop: 10 }}>
              <label style={{ display: "flex", alignItems: "center", gap: 8 }}>
                <input
                  disabled={formDisabled}
                  type="checkbox"
                  checked={altinKarsiligiMi}
                  onChange={async (e) => {
                    const checked = e.target.checked;
                    setAltinKarsiligiMi(checked);

                    // ✅ EDIT MODU: checkbox değişse bile kur setleme YOK
                    if (preventAutoKur) {
                      // Sadece checkbox flag değişsin; kur alanlarını elle değiştirirse o değişir
                      return;
                    }

                    // create modunda defaultlar yazılabilsin
                    setGuncelKurTouched(false);
                    setParaKurTouched(false);

                    if (!checked) {
                      setGuncelKur("");
                      setParaBirimiKur("");
                      return;
                    }

                    const kur = userKurLoaded ? userKurCache : await loadUserKurFromProfile();

                    const altin = Number(kur?.altinKur || 0);
                    if (altin > 0) setGuncelKur(String(altin));

                    if (form.birim === "USD") {
                      const dolar = Number(kur?.dolarKur || 0);
                      if (dolar > 0) setParaBirimiKur(String(dolar));
                    } else if (form.birim === "EUR") {
                      const euro = Number(kur?.euroKur || 0);
                      if (euro > 0) setParaBirimiKur(String(euro));
                    } else {
                      setParaBirimiKur("");
                    }
                  }}
                />
                <span>Altın karşılığı nakit işlem mi?</span>
              </label>
            </div>
          )}

          {/* =========================
              ALTIN KARŞILIĞI ALANLAR
          ========================= */}
          {isNakitPopup && altinKarsiligiMi && (
            <>
              {/* USD / EUR KURU */}
              {form.birim !== "TL" && (
                <TextField
                  disabled={formDisabled}
                  fullWidth
                  label={form.birim === "USD" ? "Dolar Kuru" : "Euro Kuru"}
                  type="number"
                  value={paraBirimiKur}
                  onChange={(e) => {
                    setParaKurTouched(true);
                    setParaBirimiKur(e.target.value);
                  }}
                  error={!!formErrors.paraBirimiKur}
                  helperText={formErrors.paraBirimiKur}
                  sx={{ mt: 2}}
                />
              )}

              {/* ALTIN KURU */}
              <TextField
                disabled={formDisabled}
                fullWidth
                label="Güncel Kur (TL / Gram)"
                type="number"
                value={guncelKur}
                onChange={(e) => {
                  setGuncelKurTouched(true);
                  setGuncelKur(e.target.value);
                }}
                error={!!formErrors.guncelKur}
                helperText={formErrors.guncelKur}
                sx={{ mt: 2}}

              />

              {/* HESAPLANAN GRAM */}
              <TextField
                label="Gram (Hesaplanan)"
                fullWidth
                value={hesaplananGram != null ? hesaplananGram.toFixed(2) : ""}
                disabled
                InputLabelProps={{ shrink: true }}
              />

            </>
          )}
        </ProsetPopup>

        <SilmeUyariPopup
          open={silmePopupOpen}
          message="Bu kaydı silmek istediğinize emin misiniz?"
          onCancel={() => setSilmePopupOpen(false)}
          onConfirm={handleDelete}
        />


      </div>
    </div>
  );
};

export default KuyumcuHesapIslemlerPage;